import Grid from '@mui/material/Unstable_Grid2';
import React from 'react';
import { useCurrentOrganisation } from '../../../../app/CurrentOrganisationProvider';
import { OrganisationTier } from '../../../../app/enums';
import { Loading, Workspace } from '../../../../design-system';
import { APIDetails } from './components/APIDetails';
import { APIPermissions } from './components/APIPermissions';
import { Details } from './components/Details';
import { Header } from './components/Header';
import { OfflineChargingSettings } from './components/OfflineChargingSettings';

const MyOrganisationView: React.FC = () => {
  const { loading, organisation } = useCurrentOrganisation();

  if (loading || !organisation) {
    return (
      <Workspace>
        <Loading />
      </Workspace>
    );
  }

  return (
    <Workspace>
      <Grid container spacing={2}>
        <Grid xs={12}>
          <Header />
        </Grid>
        <Grid xs={12}>
          <Details />
        </Grid>
        <Grid xs={12}>
          <APIDetails />
        </Grid>
        {organisation.tier === OrganisationTier.Enterprise && (
          <Grid xs={12}>
            <APIPermissions />
          </Grid>
        )}
        <Grid xs={12}>
          <OfflineChargingSettings />
        </Grid>
      </Grid>
    </Workspace>
  );
};

export default MyOrganisationView;
